/* Drainelle — thème Shopify (Wonda) */
(() => {
  const D = window.Drainelle || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const rm = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* ---------- Header pill ---------- */
  const wrap = $('#pillWrap');
  if (wrap) { const onScroll = () => wrap.classList.toggle('is-scrolled', window.scrollY > 60); addEventListener('scroll', onScroll, { passive: true }); onScroll(); }

  const ann = $('.announce');
  const setAnn = () => document.documentElement.style.setProperty('--announce-h', (ann ? ann.offsetHeight : 0) + 'px');
  addEventListener('resize', setAnn); setAnn();

  /* ---------- Bandeau mobile : rotation ---------- */
  if (ann) {
    const sp = $$('span', ann); let ai = 0;
    if (sp[0]) sp[0].classList.add('on');
    if (sp.length > 1) setInterval(() => { if (innerWidth > 900) return; sp[ai].classList.remove('on'); ai = (ai + 1) % sp.length; sp[ai].classList.add('on'); }, 3000);
  }

  /* ---------- Menu mobile ---------- */
  const burger = $('#burger');
  if (burger) {
    burger.addEventListener('click', () => { const o = document.body.classList.toggle('mm-open'); burger.setAttribute('aria-expanded', o); });
    $$('.mm a').forEach(a => a.addEventListener('click', () => document.body.classList.remove('mm-open')));
  }

  /* ---------- Reveal au scroll ---------- */
  const rv = (sel, step = 0, base = 0) => $$(sel).forEach((el, i) => { el.setAttribute('data-rv', ''); el.style.setProperty('--d', (base + i * step) + 'ms'); });
  if (!rm && 'IntersectionObserver' in window && !window.Shopify?.designMode) {
    rv('.pk', 120);
    rv('.benefits__title'); rv('.benefits__lead', 0, 140); rv('.bt', 120, 120);
    rv('.formula__title'); rv('.formula__lead', 0, 140); rv('.pl', 110); rv('.fact', 70);
    rv('.ritual__title'); rv('.ritual__lead', 0, 140); rv('.step', 130);
    rv('.reviews__title'); rv('.reviews__lead', 0, 120); rv('.reviews__card', 0, 240); rv('.rv', 70); rv('.reviews__more', 0, 200);
    rv('.faq__title'); rv('.faq__lead', 0, 120); rv('.fq', 60);
    rv('.cta__title'); rv('.cta__lead', 0, 160); rv('.cta__card', 0, 320);
    rv('.ft__col', 100); rv('.ft__bottom', 0, 200);
    rv('.pd__gallery');
    ['.pd__head', '.pd__rating', '.pd__bul', '.pd__label', '.opts', '.gifts', '.pd__cta', '.pd__pay', '.reas', '.pd__acc'].forEach((s, i) => rv(s, 0, 80 + i * 70));
    rv('.ct__title'); rv('.ct__lead', 0, 120); rv('.ct__form', 0, 200); rv('.ct__card', 90, 260);
    const io = new IntersectionObserver(es => es.forEach(e => {
      if (!e.isIntersecting) return; const el = e.target; el.classList.add('in'); io.unobserve(el);
      el.addEventListener('transitionend', ev => { if (ev.target === el && ev.propertyName === 'transform') el.removeAttribute('data-rv'); });
      if (el.matches('.fact,.reviews__score')) count(el);
    }), { threshold: .15, rootMargin: '0px 0px -6% 0px' });
    const score = $('.reviews__score'); if (score) { score.setAttribute('data-rv', ''); score.style.setProperty('--d', '120ms'); }
    $$('[data-rv]').forEach(el => io.observe(el));
  }

  /* ---------- Compteurs ---------- */
  const ease = t => 1 - Math.pow(1 - t, 3);
  function count(el) {
    const b = el.querySelector('b'); if (!b) return;
    const node = [...b.childNodes].find(n => n.nodeType === 3 && /\d/.test(n.textContent)); if (!node) return;
    const raw = node.textContent.trim(); const dec = (raw.split(',')[1] || '').length; const target = parseFloat(raw.replace(',', '.')); if (!target) return;
    const t0 = performance.now(), Dur = 1300;
    const tick = now => { const p = Math.min(1, (now - t0) / Dur); node.textContent = (target * ease(p)).toFixed(dec).replace('.', ','); if (p < 1) requestAnimationFrame(tick); };
    requestAnimationFrame(tick);
  }

  /* ---------- Logo footer : write-on ---------- */
  const ftLogo = $('.ft__logo');
  if (ftLogo && 'IntersectionObserver' in window) new IntersectionObserver((es, o) => es.forEach(e => { if (e.isIntersecting) { ftLogo.classList.add('lg-go'); o.disconnect(); } }), { threshold: .4 }).observe(ftLogo);
  else if (ftLogo) ftLogo.classList.add('lg-go');

  /* ---------- Details animés (FAQ + accordéons produit) ---------- */
  const animDetails = (d, body, dOpen = 340, dClose = 260) => {
    const sm = d.querySelector('summary'); if (!sm || !body) return; let busy = false;
    sm.addEventListener('click', e => {
      e.preventDefault(); if (busy) return; busy = true;
      if (d.open) { const h = body.offsetHeight; body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: dClose, easing: 'cubic-bezier(.4,0,.2,1)' }).onfinish = () => { d.open = false; busy = false; }; }
      else { d.open = true; const h = body.offsetHeight; body.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: dOpen, easing: 'cubic-bezier(.2,.8,.2,1)' }).onfinish = () => { busy = false; }; }
    });
  };
  $$('.fq').forEach(d => animDetails(d, d.querySelector('.fq__a')));
  $$('.pd__acc details').forEach(d => animDetails(d, d.querySelector('.acc__b'), 320, 240));

  /* ---------- Parallaxe CTA ---------- */
  const cta = $('.cta'), ctaBg = $('.cta__bg');
  if (cta && ctaBg && !rm) {
    let tk = false;
    const par = () => { tk = false; const r = cta.getBoundingClientRect(); if (r.bottom < 0 || r.top > innerHeight) return; ctaBg.style.transform = 'translateY(' + ((r.top + r.height / 2 - innerHeight / 2) * .1).toFixed(1) + 'px)'; };
    addEventListener('scroll', () => { if (!tk) { tk = true; requestAnimationFrame(par); } }, { passive: true }); par();
  }

  /* ---------- Argent ---------- */
  const fmt = cents => {
    const f = D.money || '{{amount_with_comma_separator}} €';
    const v = (cents / 100);
    const withSep = (n, dec, th, ds) => { const [i, d] = n.toFixed(dec).split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (d ? ds + d : ''); };
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      switch (k) {
        case 'amount': return withSep(v, 2, ',', '.');
        case 'amount_no_decimals': return withSep(v, 0, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return withSep(v, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withSep(v, 2, "'", '.');
        case 'amount_with_space_separator': return withSep(v, 2, ' ', ',');
        default: return withSep(v, 2, ' ', ',');
      }
    }).replace(/<[^>]+>/g, '').replace(/^\s*€\s*(.+)$/, '$1 €').replace(/\s*€\s*$/, '\u00a0€');
  };
  const num = t => parseFloat((t || '0').replace(/[^\d,.]/g, '').replace(/\.(?=\d{3})/g, '').replace(',', '.')) || 0;

  /* ---------- Modèle panier : nombre de flacons ---------- */
  const P = D.product;
  const V = {}; // bottles -> variant
  if (P && P.variants) P.variants.forEach(v => { if (!V[v.bottles] || (v.available && !V[v.bottles].available)) V[v.bottles] = v; });
  const ids = P ? new Set(P.variants.map(v => v.id)) : new Set();
  const sizes = Object.keys(V).map(Number).sort((a, b) => b - a); // ex : [5,3,1]
  const FREE = D.freeShip || 3;
  const split = t => { const out = {}; let r = t; sizes.forEach(s => { out[s] = Math.floor(r / s); r -= out[s] * s; }); if (r > 0 && sizes.includes(1)) out[1] += r; return out; };
  const priceFor = t => { const sp = split(t); return sizes.reduce((a, s) => a + sp[s] * V[s].price, 0); };
  const tierOf = t => t >= 5 ? 3 : (t >= FREE ? 2 : 1);
  const imgFor = t => (V[t >= 5 ? 5 : (t >= FREE ? 3 : 1)] || V[sizes[sizes.length - 1]] || {}).image || '';

  let cart = null;
  const bottlesIn = c => c ? c.items.filter(i => ids.has(i.variant_id)).reduce((a, i) => a + i.quantity * ((P.variants.find(v => v.id === i.variant_id) || {}).bottles || 1), 0) : 0;
  const lineTotal = c => c.items.filter(i => ids.has(i.variant_id)).reduce((a, i) => a + i.final_line_price, 0);
  const others = c => c ? c.items.filter(i => !ids.has(i.variant_id)) : [];

  const api = (url, body) => fetch(url, { method: body ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body ? JSON.stringify(body) : undefined, credentials: 'same-origin' }).then(r => r.ok ? r.json() : r.json().then(e => Promise.reject(e)));
  const R = D.routes || { cartJs: '/cart.js', cartAdd: '/cart/add.js', cartUpdate: '/cart/update.js', checkout: '/checkout' };
  const getCart = () => api(R.cartJs).then(c => (cart = c));

  /* Met le panier au découpage optimal (ex : 4 flacons = 3 mois + 1 mois) */
  const setBottles = t => {
    t = Math.max(0, t);
    const sp = split(t); const updates = {};
    P.variants.forEach(v => { updates[v.id] = 0; });
    sizes.forEach(s => { updates[V[s].id] = sp[s] || 0; });
    // si plusieurs variantes partagent une taille, on ne garde que celle de V
    return api(R.cartUpdate, { updates }).then(c => (cart = c));
  };
  const normalize = () => {
    const t = bottlesIn(cart); const sp = split(t);
    const ok = sizes.every(s => cart.items.filter(i => i.variant_id === V[s].id).reduce((a, i) => a + i.quantity, 0) === (sp[s] || 0))
      && cart.items.filter(i => ids.has(i.variant_id)).every(i => sizes.some(s => V[s].id === i.variant_id));
    return ok ? Promise.resolve(cart) : setBottles(t);
  };

  /* ---------- Pastille panier ---------- */
  const syncDot = () => { const n = cart ? cart.item_count : 0; $$('[data-cart-dot]').forEach(d => { d.hidden = n === 0; }); };

  /* ---------- Drawer ---------- */
  const dw = $('#dw'), dwBody = $('#dwBody'), dwFoot = $('#dwFoot');
  const T = D.texts || {};
  const ICO = {
    arrow: '<svg viewBox="0 0 24 24"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    truck: '<svg viewBox="0 0 24 24"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/></svg>'
  };
  const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  let busy = false;
  const loading = on => { busy = on; dw && dw.classList.toggle('is-busy', on); };

  const openDw = () => { if (!dw) return; document.body.classList.add('dw-open'); dw.setAttribute('aria-hidden', 'false'); render(); getCart().then(() => normalize()).then(() => { render(); syncDot(); }).catch(() => {}); };
  const closeDw = () => { document.body.classList.remove('dw-open'); dw && dw.setAttribute('aria-hidden', 'true'); };
  if (dw && P) {
    $('#dwX').addEventListener('click', closeDw); $('#dwOv').addEventListener('click', closeDw);
    addEventListener('keydown', e => { if (e.key === 'Escape') closeDw(); });
    $$('[data-cart-open]').forEach(a => a.addEventListener('click', e => { e.preventDefault(); openDw(); }));
    $('#dwGo').addEventListener('click', () => { location.href = R.checkout; });
  }

  let lastT, lastW = '0%';
  function render() {
    if (!dw || !P) return;
    const c = $('#dwCount'); const t = bottlesIn(cart);
    const extra = others(cart);
    if (!t && !extra.length) {
      c.textContent = ''; dwFoot.style.display = 'none';
      const rows = sizes.slice().reverse().map(k => {
        const v = V[k]; const sub = k === 1 ? '1 flacon · 30 jours' : `${k} flacons${k >= FREE ? ' · <b>livraison offerte</b>' : ''}`;
        const tag = k === 3 && T.packTag ? `<i>${esc(T.packTag)}</i>` : '';
        return `<div class="dw__p"><img src="${v.image}" alt=""><div class="t"><span class="n">${esc(v.title)}${tag}</span><span class="s">${sub}</span></div><div class="r"><span class="pr">${fmt(v.price)}</span><button type="button" data-add="${k}"${v.available ? '' : ' disabled'}>Ajouter</button></div></div>`;
      }).join('');
      dwBody.innerHTML = `<div class="dw__empty"><b>${esc(T.emptyTitle || 'Votre panier est vide')}</b><p>${esc(T.emptyText || '')}</p><div class="dw__pl">Choisissez votre rituel</div>${rows}</div>`;
      $$('[data-add]', dwBody).forEach(b => b.addEventListener('click', () => { if (busy) return; loading(true); const k = +b.dataset.add; api(R.cartAdd, { items: [{ id: V[k].id, quantity: 1 }] }).then(getCart).then(normalize).then(() => { syncOpts(bottlesIn(cart)); render(); syncDot(); }).finally(() => loading(false)); }));
      lastT = undefined; return;
    }
    dwFoot.style.display = '';
    c.textContent = '(' + t + ')';
    let html = '';
    if (t) {
      const tot = lineTotal(cart); const unit = V[1] ? t * V[1].price : tot; const lvl = tierOf(t);
      const next = t < FREE ? FREE : (t < 5 && V[5] ? 5 : null); const nextLvl = next ? tierOf(next) : null;
      const G = (P.gifts || []).filter(g => g.name);
      const got = G.map(g => { const cls = g.level <= lvl ? 'on' : (g.level === nextLvl ? 'win' : ''); const lab = g.level <= lvl ? 'Offert' : (g.level === 2 ? `Pack ${FREE} mois` : 'Pack 5 mois'); return `<span class="${cls}"><img src="${g.image}" alt=""><b>${esc(g.short)}</b><em>${lab}</em></span>`; }).join('');
      const pct = t >= 5 ? 100 : (t >= FREE ? 50 + ((t - FREE) / Math.max(1, 5 - FREE)) * 50 : ((t - 1) / Math.max(1, FREE - 1)) * 50);
      const bar = `<div class="dw__bar"><i style="width:${pct}%"></i><u style="left:${pct}%"></u></div><div class="dw__marks"><span class="${t >= 1 ? 'on' : ''}">1 mois</span><span class="${t >= FREE ? 'on' : ''}">${FREE} mois</span><span class="${t >= 5 ? 'on' : ''}">5 mois</span></div>`;
      const pctOff = n => V[1] ? Math.round((1 - priceFor(n) / (n * V[1].price)) * 100) : 0;
      const tier = next
        ? `<div class="dw__tier"><p>Pour <b>${fmt(priceFor(next) - priceFor(t))} de plus</b>, ${esc(next === FREE ? T.tier3 : T.tier5)} et vous payez chaque flacon -${pctOff(next)}&nbsp;%</p><div class="dw__got">${got}</div>${bar}<button type="button" data-set="${next}"><span class="dw__bl">${esc(next === FREE ? T.btn3 : T.btn5)}</span><i>${ICO.arrow}</i></button></div>`
        : `<div class="dw__tier"><p>${T.done || '<b>Vous avez tout débloqué.</b>'}</p><div class="dw__got">${got}</div>${bar}</div>`;
      const ship = t >= FREE
        ? `<div class="dw__ship ok"><span>${ICO.truck}<span><b>Livraison offerte</b> sur votre commande</span></span><i style="--w:100%"></i></div>`
        : `<div class="dw__ship"><span>${ICO.truck}<span>Plus que <b>${FREE - t} flacon${FREE - t > 1 ? 's' : ''}</b> pour la livraison offerte</span></span><i style="--w:${Math.round(33 + ((t - 1) / Math.max(1, FREE - 1)) * 67)}%"></i></div>`;
      const label = t === 1 ? '1 flacon · 1 mois de rituel' : `${t} flacons · ${t} mois de rituel`;
      html += `${ship}<div class="dw__item"><div class="dw__img"><img src="${imgFor(t)}" alt=""></div><div class="dw__info"><div class="dw__top"><span class="dw__name">${esc(P.title)}</span><span class="dw__price">${unit > tot ? `<s>${fmt(unit)}</s>` : ''}${fmt(tot)}</span></div><span class="dw__sub">${label}</span>
        <div class="dw__row"><span class="dw__qty"><button type="button" data-q="-1" aria-label="Retirer un flacon">−</button><span>${t}</span><button type="button" data-q="1" aria-label="Ajouter un flacon">+</button></span><button type="button" class="dw__rm" data-rm>Retirer</button></div></div></div>${tier}`;
    }
    extra.forEach(i => {
      html += `<div class="dw__item"><div class="dw__img"><img src="${i.image || ''}" alt=""></div><div class="dw__info"><div class="dw__top"><span class="dw__name">${esc(i.product_title)}</span><span class="dw__price">${i.final_line_price ? fmt(i.final_line_price) : 'Offert'}</span></div>${i.variant_title ? `<span class="dw__sub">${esc(i.variant_title)}</span>` : ''}<div class="dw__row"><span class="dw__qty"><span>× ${i.quantity}</span></span><button type="button" class="dw__rm" data-rmkey="${i.key}">Retirer</button></div></div></div>`;
    });
    dwBody.innerHTML = html;
    $('#dwTotal').textContent = fmt(cart.total_price);
    const sh = $('.dw__ship', dwBody);
    if (sh) { const b = sh.querySelector('i'); const target = b.style.getPropertyValue('--w'); b.style.setProperty('--w', lastW); requestAnimationFrame(() => requestAnimationFrame(() => { b.style.setProperty('--w', target); lastW = target; })); if (lastT !== undefined && lastT !== t) sh.classList.add('bump'); lastT = t; }
    const act = p => { if (busy) return; loading(true); p().then(() => { syncOpts(bottlesIn(cart)); render(); syncDot(); }).catch(() => getCart().then(render)).finally(() => loading(false)); };
    $$('[data-q]', dwBody).forEach(b => b.addEventListener('click', () => act(() => setBottles(t + +b.dataset.q))));
    const rmb = $('[data-rm]', dwBody); if (rmb) rmb.addEventListener('click', () => act(() => setBottles(0)));
    $$('[data-rmkey]', dwBody).forEach(b => b.addEventListener('click', () => act(() => api('/cart/change.js', { id: b.dataset.rmkey, quantity: 0 }).then(c => (cart = c)))));
    const sb = $('[data-set]', dwBody); if (sb) sb.addEventListener('click', () => act(() => setBottles(+sb.dataset.set)));
  }

  /* ---------- Page produit ---------- */
  const opts = $$('.opt');
  let syncOpts = () => {};
  if ($('.pd')) {
    const thumbs = $$('.pd__thumbs button'), mains = $$('.pd__main img'), dots = $('#pdDots');
    let cur = 0;
    const go = i => {
      if (!mains.length) return; cur = (i + mains.length) % mains.length;
      thumbs.forEach((x, k) => x.classList.toggle('on', k === cur)); mains.forEach((m, k) => m.classList.toggle('on', k === cur));
      if (dots) [...dots.children].forEach((d, k) => d.classList.toggle('on', k === cur));
      const t = thumbs[cur]; const list = t && t.parentElement;
      if (t && list) { const r = t.getBoundingClientRect(), lr = list.getBoundingClientRect(); if (r.top < lr.top || r.bottom > lr.bottom) list.scrollBy({ top: r.top - lr.top - 8, behavior: 'smooth' }); if (r.left < lr.left || r.right > lr.right) list.scrollBy({ left: r.left - lr.left - 8, behavior: 'smooth' }); }
    };
    if (dots) mains.forEach((m, k) => { const d = document.createElement('i'); d.addEventListener('click', () => go(k)); dots.appendChild(d); });
    go(0);
    thumbs.forEach(b => b.addEventListener('click', () => go(+b.dataset.i)));
    const mainEl = $('.pd__main');
    if (mainEl) { let sx = 0, sy = 0, sw = false;
      mainEl.addEventListener('pointerdown', e => { sx = e.clientX; sy = e.clientY; sw = true; });
      mainEl.addEventListener('pointerup', e => { if (!sw) return; sw = false; const dx = e.clientX - sx, dy = e.clientY - sy; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(cur + (dx < 0 ? 1 : -1)); });
      mainEl.addEventListener('pointercancel', () => { sw = false; });
    }
    addEventListener('keydown', e => { if (e.target.closest('input,textarea,select')) return; if (e.key === 'ArrowRight') go(cur + 1); if (e.key === 'ArrowLeft') go(cur - 1); });

    const tween = (el, to) => {
      if (!el) return; const from = num(el.textContent) * 100; if (Math.round(from) === to) return;
      if (rm) { el.textContent = fmt(to); return; }
      el.classList.remove('p-up', 'p-down'); void el.offsetWidth; el.classList.add(to > from ? 'p-up' : 'p-down');
      const t0 = performance.now(), Dur = 520;
      const step = now => { const k = Math.min(1, (now - t0) / Dur); el.textContent = fmt(Math.round(from + (to - from) * ease(k))); if (k < 1) requestAnimationFrame(step); };
      requestAnimationFrame(step);
    };
    const setOld = (el, v) => { if (!el || el.textContent === v) return; el.classList.remove('p-fade'); void el.offsetWidth; el.textContent = v; el.classList.add('p-fade'); };
    const apply = o => {
      if (!o) return;
      opts.forEach(x => x.classList.toggle('on', x === o));
      const pr = +o.dataset.price, old = +o.dataset.old;
      tween($('#ctaPrice'), pr); tween($('#hpPrice'), pr); tween($('#sbPrice'), pr);
      setOld($('#ctaOld'), old > 0 ? fmt(old) : '');
      const sbN = $('#sbName'), sbS = $('#sbSub'), sbI = $('#sbImg');
      if (sbN) sbN.textContent = o.dataset.name; if (sbS) sbS.textContent = o.dataset.sub; if (sbI) sbI.src = o.dataset.img;
      const lv = +o.dataset.lvl; $$('.gift').forEach(g => g.classList.toggle('ok', +g.dataset.lvl <= lv));
      const isOne = +o.dataset.bottles === 1; const lab = isOne ? 'Ajouter au panier' : 'Commander';
      const cl = $('#ctaLabel'), sl = $('#sbLabel'); if (cl) cl.textContent = lab; if (sl) sl.textContent = lab;
      try { const u = new URL(location.href); u.searchParams.set('variant', o.dataset.id); history.replaceState(null, '', u); } catch (e) {}
    };
    apply($('.opt.on') || opts[0]);
    opts.forEach(o => { const inp = o.querySelector('input'); inp && inp.addEventListener('change', () => apply(o)); });
    syncOpts = t => { if (!t) return; const k = t >= 5 ? 5 : (t >= FREE ? 3 : 1); const o = opts.find(x => +x.dataset.bottles === k); if (o && !o.classList.contains('on')) { o.querySelector('input').checked = true; apply(o); } };

    /* Barre sticky */
    const sbar = $('#sbar'), box = $('.pd__cta');
    if (sbar && box) {
      let sbT = false;
      const sbUp = () => { sbT = false; const r = box.getBoundingClientRect(); const ft = $('.ft'); const ftTop = ft ? ft.getBoundingClientRect().top : Infinity; sbar.classList.toggle('show', r.bottom < 0 && ftTop > innerHeight); };
      addEventListener('scroll', () => { if (!sbT) { sbT = true; requestAnimationFrame(sbUp); } }, { passive: true }); sbUp();
    }

    /* Ajout : 1 mois → drawer (upsell) · 3 / 5 mois → checkout direct */
    const add = btn => {
      const o = $('.opt.on'); if (!o || busy) return;
      const k = +o.dataset.bottles; const id = +o.dataset.id;
      btn.classList.add('is-loading'); loading(true);
      api(R.cartAdd, { items: [{ id, quantity: 1 }] })
        .then(getCart).then(normalize)
        .then(() => {
          syncDot();
          if (k === 1 && dw) { openDw(); render(); }
          else location.href = R.checkout;
        })
        .catch(err => { alert((err && (err.description || err.message)) || 'Impossible d’ajouter au panier pour le moment.'); })
        .finally(() => { btn.classList.remove('is-loading'); loading(false); });
    };
    const ab = $('#addBtn'); if (ab) ab.addEventListener('click', () => add(ab));
    const sbb = $('.sbar__btn'); if (sbb) sbb.addEventListener('click', () => add(sbb));
  }

  /* ---------- Contact : état envoyé ---------- */
  const ctf = $('#ctForm'); if (ctf && ($('[data-ct-sent]', ctf) || /contact_posted=true/.test(location.search))) ctf.classList.add('sent');

  /* ---------- Init panier ---------- */
  if (P) getCart().then(() => { syncDot(); }).catch(() => {});
  document.addEventListener('shopify:section:load', () => location.reload());
})();
